import {useTranslation} from 'react-i18next'

import {ShutdownDrillingDTO} from '@refra/modules/refra-planning/types'

const negativeColor = 'text-red-500'

export function DrillingChartTooltip({
  meter,
  drillingsByMeter,
  calculateItemColor
}: {
  meter: number
  drillingsByMeter: Partial<Record<number, ShutdownDrillingDTO[]>>
  calculateItemColor: (
    item: ShutdownDrillingDTO,
    defaultColor?: string,
    negativeColor?: string
  ) => string
}) {
  const {t} = useTranslation()
  const tooltipContent = drillingsByMeter[meter]?.sort((a, b) => b.depth - a.depth)
  if (!tooltipContent) return null
  return (
    <div
      className="bg-gray-900 text-white max-w-96 p-4 rounded-md font-bold"
      data-cy="drillings_tooltip"
    >
      <div className="pb-1" data-cy="drillings_tooltip_title">
        <span>{`${t('common.meter')} ${meter}`}</span>
      </div>
      <div className="flex flex-col" data-cy="drillings_tooltip_positions">
        {tooltipContent.map((drilling) => (
          <div
            key={drilling.id}
            className={`flex items-center gap-1 ${calculateItemColor(drilling, '', negativeColor)}`}
          >
            <span>{drilling.drillingPosition.name}</span>
            <span>-</span>
            <span>{drilling.depth}</span>
            <span>{t('common.mm')}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
